import { styled } from 'styled-components';
import { ReactComponent as SearchSvg } from '../../assets/icons/search.svg';
import { ReactComponent as Add } from '../../assets/icons/add.svg';

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  background-color: #faf5f6;
  gap: 33px;
  padding-right: 33px;
  @media (max-width: 800px) {
    padding-top: 50px;
    padding-left: 33px;
  }
`;
export const ContentContainer = styled.div`
  padding-bottom: 100px;
  padding-left: 265px;
  width: 100%;
  @media (max-width: 800px) {
    padding-left: 0;
  }
`;

export const InboxContainer = styled.div`
  width: 100%;
  flex: 1;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-height: 554px;
`;
export const MessageContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 12px 16px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
`;
export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
export const Name = styled.span`
  font-size: 15px;
  font-family: 'Poppins-Medium';

  letter-spacing: -0.408px;
`;
export const Time = styled(Name)`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  margin-left: 46px;
`;
export const Message = styled(Name)`
  font-size: 12px;
  max-width: 487px;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: row;
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
export const PaginationContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 1.6rem 2.4rem;
  flex: 1;
`;
export const LeftSideInbox = styled.div`
  border-radius: 10px;
  background: #fff;
  display: inline-flex;
  flex-direction: column;
  align-items: ${props => (props.$empty ? 'center' : 'flex-start')};
  justify-content: ${props => (props.$empty ? 'center' : 'flex-start')};
  // gap: 4px;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);
  max-height: 675px;
  height: fit-content;
  overflow: auto;
  width: 276px;
`;

export const ChatRoomsContainer = styled.div`
  width: 100%;
`;

export const Frame = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  display: flex;
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
`;
export const RightSide = styled.div`
  display: flex;
  width: 815px;
  height: 733px;
  padding-bottom: 0px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid #e0bcc3;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);
  @media (max-width: 1100px) {
    width: 100%;
  }
`;
export const Inbox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex-wrap: wrap;
`;

export const Chat = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  width: 100%;
`;
export const ChatHeader = styled.div`
  background: #faf5f6;
  display: flex;
  padding: 12px 16px;
  justify-content: space-between;
  align-items: center;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  align-self: stretch;
`;
export const ChatInput = styled.input`
  border: none;
  width: 100%;
  background-color: transparent;
  &:focus {
    outline: none;
  }
`;
export const PaddingHorizontal = styled.div`
  padding: 20px 16px;
  flex-direction: column;
  // flex: 1;
  width: 100%;
  display: flex;
`;
export const AddIcon = styled(Add)`
  cursor: pointer;
  position: absolute;
  right: 20px;
  height: 2.4rem;
  width: 2.4rem;
`;
export const ChooseFile = styled.input`
  opacity: 0;
  position: absolute;
  cursor: pointer;
  right: 20px;
  height: 2.4rem;
  width: 2.4rem;
  border-radius: 50%;
  z-index: 2;
`;

export const Relative = styled.div`
  position: relative;
  align-items: center;
  justify-content: center;

  display: flex;

  padding: 12px 64px 12px 20px;
  background: #f8e5e9;
  align-items: center;

  gap: 10px;

  border-radius: 20px;
`;
export const EmptyChat = styled.div`
  flex: 1;
  width: 100%;

  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const ReceivedTime = styled.span`
  margin-top: auto;
  color: rgba(30, 30, 30, 0.2);
  font-family: 'Poppins-Regular';

  font-size: 12px;

  letter-spacing: -0.24px;
  margin-bottom: 5px;
`;

export const PhotoMedia = styled.img`
  width: 20rem;
  height: 15rem;
  object-fit: cover;
  cursor: pointer;
  border-radius: 1rem;
`;
export const VideoMedia = styled.video`
  width: 20rem;
  height: 15rem;
  object-fit: cover;
  cursor: pointer;
  border-radius: 1rem;
`;
export const ReceivedMessage = styled.span`
  color: #fff;
  font-family: 'Poppins-Regular';

  font-size: 14px;
  letter-spacing: -0.28px;
`;
export const ReceivedContainer = styled.div`
  display: flex;
  padding: 10px 20px;
  align-items: flex-start;
  gap: 10px;
  width: fit-content;
  border-radius: 100px;
  background: #1e1e1e;
`;
export const Received = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SentTime = styled.span`
  margin-top: auto;
  color: rgba(30, 30, 30, 0.2);
  font-size: 12px;
  font-family: 'Poppins-Regular';
  letter-spacing: -0.24px;
  margin-bottom: 2px;
`;
export const SentMessage = styled.span`
  font-family: 'Poppins-Regular';

  font-size: 14px;

  letter-spacing: -0.28px;
`;
export const SentContainer = styled.div`
  display: flex;
  padding: 10px 20px;
  align-items: flex-start;
  gap: 10px;
  width: fit-content;
  border-radius: 100px;
  background: #f8e5e9;
`;
export const Sent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;
  display: flex;
`;
export const Messages = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ScrollContent = styled.div`
  max-height: 562px;
  display: flex;
  gap: 12px;
  flex-direction: column-reverse;
  overflow-y: scroll;
  padding-right: 5px;
`;

export const LoadingContainer = styled.div`
  flex: 1;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LeftLoadingContainer = styled.div`
  width: 100%;
  padding: 15px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DotContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

export const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: red;
  margin-right: 15px;
`;

export const StyledInput = styled.div`
  position: relative;
  height: fit-content;
  cursor: pointer;
`;

export const IconContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
`;
export const Search = styled.input`
  border-radius: 10px;
  font-family: 'Poppins-Medium';

  width: 100%;

  user-select: none;
  height: 45px;

  background: #fff;
  /* box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05); */
  border: none;
  padding-left: 42px;
  transition: all 0.2s ease-in-out;
  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
  &::placeholder {
    opacity: 0.75;
    font-family: 'Poppins-Medium';

    font-size: 12px;

    letter-spacing: 0.067px;
  }
`;

export const SearchIcon = styled(SearchSvg)`
  width: 20px;
  height: auto;
  path {
    stroke-width: 1.75;
  }
`;
